import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import UniversalDetailsHOC from './UniversalDetailsHOC';
import TableBuilder from './TableBuilder';
import './UniversalDetails.scss';
import history from '../../config/history';
import Loading from '../../components/Loading';
// import SendRfq from '../../components/Modals/SendRfq';


class UniversalDetails extends React.PureComponent {
  static propTypes = {
    niinData: PropTypes.any.isRequired,
    cageData: PropTypes.any.isRequired,
    udHistory: PropTypes.any.isRequired,
    isLoading: PropTypes.any.isRequired,
    addToolinCommentGov: PropTypes.func.isRequired,
    auth: PropTypes.any.isRequired,
    // closeRfqModal: PropTypes.func.isRequired,
    // closeProcGroupModal: PropTypes.func.isRequired,
    // modalRfqOpen: PropTypes.bool.isRequired,
    // modalProcGroupVisible: PropTypes.bool.isRequired,
    sendRFQ: PropTypes.func.isRequired,
    // rfqInput: PropTypes.instanceOf(Object).isRequired,
    // showSendRfq: PropTypes.bool.isRequired,
  };

  _entries = keys => {
    const Pkeys = keys.map(key => <p>{key}</p>);
    return Pkeys;
  };



  render() {
    // const { niinData, cageData, udHistory, addToolinCommentGov, auth, isLoading, modalProcGroupVisible, modalRfqOpen, closeRfqModal, closeProcGroupModal, openRfqModal, rfqInput } = this.props;
    const { niinData, cageData, udHistory, addToolinCommentGov, auth, isLoading, sendRFQ } = this.props;
    return (
      <div>
        {isLoading && (
          <div>
            <Loading text="Gathering Data..." />
          </div>
        )}
        {!isLoading && (
          <div>
            <div id="mybutton">
              <Button
                className="floating-back"
                onClick={() => {
                  history.goBack();
                }}
              >
                Go Back
              </Button>
            </div>

            <div className='nf-u-details__grid'>
              <div className='sendRFQ'>
                <Button id="sndRFQ"
                  onClick={sendRFQ}
                  type="primary"
                  style={{
                    background: '#ff7c52',
                    border: '#ff7c52',
                    borderRadius: '6px',
                  }}
                >
                  Send RFQ
                </Button>
              </div>
            </div>






            {udHistory && Object.entries(udHistory).map(block => TableBuilder(block))}
            {cageData && Object.entries(cageData).map(block => TableBuilder(block, auth, addToolinCommentGov))}
            {niinData && Object.entries(niinData).map(block => TableBuilder(block))}
            {/* <SendRfq
              auth={this.props.auth}
              // solicitationId={this.props.id}
              // tool={udHistory.toolingSearch[0]}
              closeRfqModal={closeRfqModal}
              closeProcGroupModal={closeProcGroupModal}
              modalRfqOpen={modalRfqOpen}
              modalProcGroupVisible={modalProcGroupVisible}
              rfqInput={rfqInput}
            /> */}
          </div>
        )}
      </div>
    );
  }
}

export default UniversalDetailsHOC(UniversalDetails);



// WEBPACK FOOTER //
// ./src/pages/universalDetails/UniversalDetails.jsx